import Events from '../ads/media/Events';
import mediaEvents from '../ads/media/mediaEvents';
function info(data) {
    if (!data) {
        return;
    }
    mediaEvents.event(Events.Logging.info).emit(data);
}
function error(err) {
    if (!err) {
        return;
    }
    mediaEvents.event(Events.Logging.error).emit(err);
}
function debug(message, context = '') {
    if (!this.debugEnabled) {
        return;
    }
    console.warn(`[mint] ${message}`, context);
}
export default {
    info,
    error,
    debug,
};
